import {
  FormItem as FormItemModel,
  FormItemOption,
  FormItemTypes,
} from '@models/Form'
import { Checkbox, Input, Rate, Select, Space } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { ReactNode } from 'react'

interface Props {
  item: FormItemModel
  isFulfilled: boolean
}

export const useFormItemControl = ({ item, isFulfilled }: Props) => {
  const controls: Record<
    FormItemTypes,
    {
      name: 'answer' | 'options'
      content: (value?: any, options?: FormItemOption[]) => ReactNode
    }
  > = {
    [FormItemTypes.Input]: {
      name: 'answer',
      content: (value) => (
        <Input value={value} disabled={isFulfilled} variant="outlined" />
      ),
    },
    [FormItemTypes.TextArea]: {
      name: 'answer',
      content: (value) => (
        <TextArea rows={4} value={value} disabled={isFulfilled} />
      ),
    },
    [FormItemTypes.Select]: {
      name: 'options',
      content: (_, options) => (
        <Select
          className="w-full"
          mode="multiple"
          maxCount={1}
          defaultValue={options?.map((o) => o.id)}
          disabled={isFulfilled}
          options={item.options?.map((option) => ({
            value: option.id,
            label: option.name,
          }))}
        />
      ),
    },
    [FormItemTypes.CheckboxGroup]: {
      name: 'options',
      content: (_, options) => (
        <Checkbox.Group
          disabled={isFulfilled}
          defaultValue={options?.map((o) => o.id)}
        >
          <Space size={0} vertical>
            {item.options?.map((option) => (
              <Checkbox key={option.id} value={option.id}>
                {option.name}
              </Checkbox>
            ))}
          </Space>
        </Checkbox.Group>
      ),
    },
    [FormItemTypes.Rate]: {
      name: 'answer',
      content: (value) => (
        <Rate
          value={value}
          style={{ fontSize: 35 }}
          className="w-full"
          disabled={isFulfilled}
        />
      ),
    },
    [FormItemTypes.Title]: { name: 'answer', content: () => <></> },
    [FormItemTypes.Spacer]: { name: 'answer', content: () => <></> },
  }

  return controls[item.type.id as FormItemTypes]
}
